export default __webpack_public_path__ + "static/media/dextools.391eb1e8.png";